// 
// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CustomNavbar from './Components/Navbar';
import Home from './Pages/Home';
import AboutUs from './Pages/AboutUs';
import Services from './Pages/Services';
import Infrastructure from './Pages/Infrastructure';
import Quality from './Pages/Quality';
import ContactUs from './Pages/ContactUs';
import './App.css'; // Import the styles here
import MobileNavbar from './Components/MobileNavbar';


const App = () => {
  return (
    <>
   
    <Router>
      <div className='side-bar-menu'>
      <CustomNavbar />
      </div>
      <div className='mobile-menu'>
      <MobileNavbar/>
      </div>
      <div className="content" >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/infrastructure" element={<Infrastructure />} />
          <Route path="/quality" element={<Quality />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
   
      </div>
  
    </Router>

     {/* */}

    </>
  );
}

export default App;
